import React from 'react';
import classNames from 'classnames';
import Avatar from '@alltrails/shared/components/Avatar';
import User from '@alltrails/shared/types/User';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

type UserImageLinkProps = {
  user: User & { firstName?: string; lastName?: string };
  className?: string;
  size48?: boolean;
};

const UserImageLink = ({ user, className, size48 }: UserImageLinkProps) => {
  const languageRegionCode = useLanguageRegionCode();
  if (!user) {
    return null;
  }

  const linkClass = size48 ? styles.link48 : styles.link;

  return (
    <a
      className={classNames('clickable', linkClass, StringConstantsMixin.constants.XLATE.NONE, className)}
      href={LanguageSupportUtil.wrapUrlSafe(ServerCommunicationUtil.usersPath(user), languageRegionCode)}
      target="_blank"
      title={`${user.firstName} ${user.lastName}`}
      onClick={e => e.stopPropagation()}
      rel="noreferrer"
    >
      <Avatar
        name={StringConstantsMixin.strings.USER_AVATAR_ALT}
        src={
          user.profile_photo_url
            ? user.profile_photo_url
            : `/api/alltrails/profile_photos/${user.id}/image?size=icon&key=${ServerCommunicationUtil.apiKey}`
        }
        lazy
        fill
      />
    </a>
  );
};

export default UserImageLink;
